export const SUBMISSION_COMPLETE_MESSAGE = [
  'Thank You For Your Submission!',
  'We will begin reviewing the file now',
  'and provide feedback shortly.'
];

export const HOMEPAGE_LINK = {
  text: 'Home',
  link: '/portal'
};

export const SUBMIT_ERROR_MESSAGE = [
  "Sorry for the inconvenience, the application failed to submit.",
  "Please email your application and bank statements to your Account Manager."
];

export const LOADING_MESSAGE = [
  'Please Wait',
  'The files are being uploaded.'
];

export const SUBMISSION_DISABLED_MESSAGE = [
  `Sorry for the inconvenience,
              the submission page is temporarily unavailable.`,
  "Please try again later or contact your Account Manager."
];
